import React from 'react'

export const Error = () => {
  return (
    <div>404 NOT FOUND</div>
  )
}
